import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      height: theme.sizingLarge,
      minWidth: theme.sizingMedium * 8,
      maxWidth: theme.sizingMedium * theme.sizingSmall,
      borderRadius: theme.borderRadiusPill,
      borderWidth: theme.borderWidthQuarterpulse,
      paddingHorizontal: theme.paddingInsetFourpulse,
      alignItems: 'center',
      flexDirection: 'row',
      gap: theme.spacingInlineTwopulse,
    },
    variants: {
      type: {
        neutral: {
          backgroundColor: theme.colorFillNeutralAlternative,
          borderColor: theme.colorBorderNeutralDefault,
        },
        informative: {
          backgroundColor: theme.colorFillInformativeAlternative,
          borderColor: theme.colorBorderNeutralDefault,
        },
        success: {
          backgroundColor: theme.colorFillSuccessAlternative,
          borderColor: theme.colorBorderNeutralDefault,
        },
        warning: {
          backgroundColor: theme.colorFillWarningAlternative,
          borderColor: theme.colorBorderNeutralDefault,
        },
        danger: {
          backgroundColor: theme.colorFillDangerAlternative,
          borderColor: theme.colorBorderNeutralDefault,
        },
      },
    },
  }
})
